module.exports = __webpack_public_path__ + "static/media/mg_group_ui_assets_identidad.6cb7e201.svg";